"use client";

import {RadioGroup} from "@headlessui/react";
import clsx from "clsx";
import React from "react";
import useRudderStackAnalytics from "@/common/use-rudder-analytics";

const frequencies = [
  {value: 'month', label: 'Monthly', priceSuffix: '/month'},
  {value: 'year', label: 'Annually', priceSuffix: '/year'},
]

export function FrequencySelector({frequency, setFrequency}: Readonly<{ frequency: string, setFrequency: React.Dispatch<React.SetStateAction<string>> }>) {
  const analytics = useRudderStackAnalytics();

  return (
    <div className="mt-16 flex justify-center">
      <RadioGroup
        value={frequency}
        className="grid grid-cols-2 gap-x-1 rounded-full p-1 text-center text-xs font-semibold leading-5 ring-1 ring-inset ring-gray-200"
        onChange={() => {
          setFrequency(frequency === 'month' ? 'year' : 'month')
          analytics?.track('pricing_frequency_changed', {frequency: frequency === 'month' ? 'year' : 'month'});
        }}
      >
        <RadioGroup.Label className="sr-only">Payment frequency</RadioGroup.Label>
        {frequencies.map((option) => (
          <RadioGroup.Option
            key={option.value}
            value={option}
            className={clsx(option.value === frequency ? 'bg-indigo-600 text-white' : 'text-gray-500', 'cursor-pointer rounded-full px-2.5 py-1')}
          >
            <span>{option.label}</span>
          </RadioGroup.Option>
        ))}
      </RadioGroup>
    </div>
  )
}